module.exports = __webpack_public_path__ + "static/media/workingmemory-words-10.72664360.mp3";